/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Guide_UnknownInputs */

const en_knp_guide_unknown = /** @type {(inputs: Knp_Guide_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unknown`)
};

const fr_knp_guide_unknown = /** @type {(inputs: Knp_Guide_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inconnu`)
};

const de_knp_guide_unknown = /** @type {(inputs: Knp_Guide_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unbekannt`)
};

const it_knp_guide_unknown = /** @type {(inputs: Knp_Guide_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sconosciuto`)
};

const ru_knp_guide_unknown = /** @type {(inputs: Knp_Guide_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Неизвестный`)
};

const es_knp_guide_unknown = /** @type {(inputs: Knp_Guide_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desconocido`)
};

const zh_cn2_knp_guide_unknown = /** @type {(inputs: Knp_Guide_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未知`)
};

const ja_knp_guide_unknown = /** @type {(inputs: Knp_Guide_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未知`)
};

const hi_knp_guide_unknown = /** @type {(inputs: Knp_Guide_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अज्ञात`)
};

const pt_pt2_knp_guide_unknown = /** @type {(inputs: Knp_Guide_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desconhecido`)
};

/**
* | output |
* | --- |
* | "Unknown" |
*
* @param {Knp_Guide_UnknownInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_guide_unknown = /** @type {((inputs?: Knp_Guide_UnknownInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Guide_UnknownInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_guide_unknown(inputs)
	if (locale === "de") return de_knp_guide_unknown(inputs)
	if (locale === "it") return it_knp_guide_unknown(inputs)
	if (locale === "ru") return ru_knp_guide_unknown(inputs)
	if (locale === "es") return es_knp_guide_unknown(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_guide_unknown(inputs)
	if (locale === "ja") return ja_knp_guide_unknown(inputs)
	if (locale === "hi") return hi_knp_guide_unknown(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_guide_unknown(inputs)
	return en_knp_guide_unknown(inputs)
});